import React from 'react'

function StaticOverviewTableThead(props) {
    return (
        <thead className='StaticOverviewTableThead'>
            <tr>
                <th className="Name">Nhân viên</th>
                <th className="smallStaticCol">In</th>
                <th className="StaticCol">QC sau ép</th>
                <th className="StaticCol">QC sau ép lỗi</th>
                <th className="StaticCol">QC hoàn thành 2D</th>
                <th className="StaticCol">QC hoàn thành 3D lần 1</th>
                <th className="StaticCol">QC hoàn thành 3D</th>
                <th className="StaticCol">QC hoàn thành lỗi</th>
                <th className="StaticCol">Dán label</th>
                <th className="StaticCol">Đóng thùng</th>
                <th className="StaticCol">Print QR</th>
                <th className="StaticCol">Thiết kế thêu</th>
                <th className="StaticCol">Đã thêu</th>
                <th className="StaticCol">Đánh dấu hoàn thiện</th>

            </tr>
        </thead>
    )
}

export default StaticOverviewTableThead
